import React, { useEffect, useState } from "react";
import AddEditForm from "./AddEditFormUsers";
import { axios } from "../../../../Global";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ListDataUser from "./ListDataUser";
// import useCRUD from "../../../hooks/useCRUD";
import PromptElement from "../../PromptElement";
import { printValidationError } from "../../../../utils/functions";
import { getUserLists } from "../../../../store/Api";
import { checkAccessFn } from "../../../../utils/checkAccess";

export default function Users(props) {
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [clientList, setClientList] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create") {
      setAddOrEdit((p) => ({ ...p, open: true }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [roles, setRoles] = useState([]);
  const [userRoles, setUserRoles] = useState([]);

  const token = localStorage.getItem("token");

  const getUsersAndRoles = () => {
    setLoading({ listData: true });
    axios
      .get("/dashboard/user", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
         setLoading({ listData: false });
        setClientList(res.data.data);
      })
      .catch((err) => {
      setLoading({ listData: false });
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      });

    axios
      .get("/dashboard/roles", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setRoles(res.data.data);
        setLoading({ listData: false });
      })
      .catch((err) => {
        setLoading({ listData: false });
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      });
    setLoading({ listData: false });
  };

  useEffect(() => {
   
    getUsersAndRoles();
    
  }, []);

  const submitForm = async (event, selectedRoles = []) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = {
        name,
        email,
        mobile,
        roles: selectedRoles,
        address,
      };
      if (password.trim() !== "") {
        body.password = password;
      }
      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/user`, body, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (addOrEdit.method === "edit") {
        response = await axios.put(
          `/dashboard/user/${addOrEdit.editId}`,
          body,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      getUsersAndRoles();
      const data = response.data.data;
      if (data) {
        navigate("/dashboard/users");
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "success",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      console.log(err);
      printValidationError(err, "users");
      setSubmitFormLoading(false);
      dispatch(
        setAppError({
          msg: err?.response?.data?.message || "Something went wrong!",
        })
      );
    }
  };
  const cancelForm = () => {
    navigate("/dashboard/users");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id) => {
    navigate(`/dashboard/users/edit/${id}`);
    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        const response = await axios.get(`/dashboard/user/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = response?.data?.data?.user;

        setUserRoles(data?.roles)?.user;
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          editId: id,
        }));
        setName(data?.name);
        setEmail(data?.email);
        setPassword("");
        setMobile(data?.user_detail?.mobile);
        setAddress(data?.user_detail?.address);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(`/dashboard/user/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        getUsersAndRoles();
        if (response.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }

        setLoading((p) => ({ ...p, delete: false }));

        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setName("");
    setEmail("");
    setPassword("");
    setMobile("");
    setAddress("");
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
           
            <ListDataUser
              list={clientList}
              editData={editData}
              deleteData={setShowPromptElement}
              loading={loading}
              listLoading={loading.listData}
              column={5}
              titles={["SL No.", "Name", "Email", "Action"]}
              addData={checkAccess("User", "user-create") ? addData : undefined}
            />
          </>
        )}
        {addOrEdit.open && (
          <AddEditForm
            component="users"
            form={[
              {
                type: "text",
                text: "Name",
                name: "name",
                value: name,
                update: setName,
                columnName: "name",
                required: true,
              },
              {
                type: "email",
                text: "Email",
                name: "email",
                value: email,
                update: setEmail,
                columnName: "email",
                required: true,
              },
              {
                type: "password",
                text: "Password",
                name: "password",
                value: password,
                update: setPassword,
                columnName: "password",
                required: false,
              },
              {
                type: "number",
                text: "Mobile No.",
                name: "mobile",
                value: mobile,
                update: setMobile,
                columnName: "mobile",
                required: true,
                pattern: "[0-9]*",
              },
              {
                type: "textarea",
                text: "Address",
                name: "address",
                value: address,
                update: setAddress,
                columnName: "address",
                required: true,
              },
            ]}
            roles={roles}
            userRoles={userRoles}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={
              addOrEdit.method === "edit" && addOrEdit.loadedValues
                ? true
                : false
            }
          />
        )}
      </div>
    </>
  );
}
